import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import { useTenantContext } from '@/context'
import { getTenantConfigurationOptionValue } from '@/utils/tenant-configuration-option'

export const DonorPortalScreenMessage = ({ code }) => {
  const { tenant } = useTenantContext()
  const message = useMemo(
    () =>
      getTenantConfigurationOptionValue(tenant?.configuration_options, code),
    [tenant?.configuration_options, code]
  )

  if (!message) return null

  return (
    <Box
      sx={{ mb: 2 }}
      className='donor-portal-screen-message'
      dangerouslySetInnerHTML={{ __html: message }}
    />
  )
}
